import React from 'react';
import { warrantyIds } from '../../../../config';
import NotWarrantyComponent from '../NotWarrantyComponent/NotWarrantyComponent';
import PossWarrantyComponent from '../PossWarrantyComponent/PossWarrantyComponent';
import WarrantyComponent from '../WarrantyComponent/WarrantyComponent';

const ActiveComponent = ({ request, actionProps }) => {
  const { garantyId } = request;

  switch (garantyId) {
    case warrantyIds.notWarranty:
      return (
        <NotWarrantyComponent
          request={request}
          actionProps={actionProps}
        />
      );

    case warrantyIds.possWarranty:
      return (
        <PossWarrantyComponent
          request={request}
          actionProps={actionProps}
        />
      );

    case warrantyIds.warranty:
      return (
        <WarrantyComponent
          request={request}
          actionProps={actionProps}
        />
      );

    default:
      return null;
  }
};

export default ActiveComponent;
